import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnknownPlatformLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26.34 25.02",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 26.3374,
		height: 25.0206,
		fill: "#4F31FF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.1127 15.8411H14.5527L14.7927 14.5211C17.0927 13.9611 18.8527 12.8611 18.8527 10.2411V10.2011C18.8527 7.48109 16.7327 5.84109 13.6927 5.84109C11.3327 5.84109 9.61271 6.76109 8.35271 8.04109L10.4127 10.6411C11.3927 9.76109 12.4527 9.26109 13.4527 9.26109C14.4927 9.26109 15.0927 9.72109 15.0927 10.4611V10.5011C15.0927 11.4411 14.2127 12.0411 11.7527 12.2211L11.5927 12.3811L12.1127 15.8411ZM11.2927 20.6211H15.2527V17.1211H11.2927V20.6211Z",
		fill: "white"
	})]
});
export default SvgUnknownPlatformLogo;
